import React from 'react';
const styles = require('./divider.component.scss');

export interface DividerProps {
    direction: 'vertical' | 'horizontal' ;
    className? : string;
}
export function Divider(props: DividerProps) {
    const {direction, className} = props;
    return (
        <div className={`${styles.dividerCont} ${className || ''}`}>
            <div className={`${styles.divider} ${styles[direction] }`}/>
        </div>
    );
}